module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_9006.ad3a4daa.png";